module.exports = __webpack_public_path__ + "img/bpd.feab8af0.png";